// extracted by mini-css-extract-plugin
module.exports = {"grid-title":"EmployeeStoriesGrid_grid-title__CVobb","grid-section":"EmployeeStoriesGrid_grid-section__2cyQ_","employee-card-grid":"EmployeeStoriesGrid_employee-card-grid__X79Ec"};